import React from "react"
import useTabManager from "hooks/useTabManager"

interface TabLockOverlayProps {
  children: React.ReactNode
}

const TabLockOverlay: React.FC<TabLockOverlayProps> = ({ children }) => {
  const { isActiveTab, isTabLocked, reloadPage } = useTabManager()

  if (isActiveTab && !isTabLocked) return <React.Fragment>{children}</React.Fragment>

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-80 flex items-center justify-center">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 text-center shadow-2xl">
        <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
          <div className="flex items-center justify-center mb-2">
            <span className="text-yellow-600 text-lg">⚠️</span>
          </div>
          <p className="text-yellow-800 text-sm">
            Only one tab can be active at a time to prevent conflicts and ensure data consistency.
          </p>
        </div>

        <button
          onClick={reloadPage}
          className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
          Reload and Activate This Tab
        </button>

        <p className="text-xs text-gray-500 mt-4">Reloading will deactivate other tabs and make this one active.</p>
      </div>
    </div>
  )
}

export default TabLockOverlay
